<template>
  <div class="view match">
    <component :is="activeView" />
  </div>
</template>

<script>
export default {
  // mounted() {
  //   console.log("this.creator_id.creator_id")
  //   console.log(this.creator_id.creator_id)
  // },
  computed: {
    activeView() {
      // Get status of the Match
      const isOngoing = this.$store.state.isGameOver;
      const isOnBreak = this.$store.state.isOnBreak;
      const mystery = this.$store.state.mystery;
      const spin = this.$store.state.has_spin;
      const slide = this.$store.state.has_video;

      console.log('mystery',mystery)
      if (!isOngoing)
        return () => import("../components/Prequiz.vue");

      if(isOnBreak) {
        if (this.$store.state.matchSlug ==628) {
          if (this.$store.state.round == 3) {
            if (spin) {
              return () => import("../components/SpinTheWheel.vue");
            }
          }
        }
        if (this.$store.state.matchSlug == 995) {
          if (this.$store.state.round == 2) {
            if (this.$store.state.has_game === '1_to_25') {
              return () => import("../components/1to50.vue");
            }

            if (this.$store.state.has_game === 'tic_tac_toe') {
              return () => import("../components/TicTacToe.vue");
            }
          }
          if (this.$store.state.round == 4) {
            return () => import("../components/video.vue");
          }
        }
        else if (this.$store.state.matchSlug == 806) {
          if (this.$store.state.round == 2) {
              return () => import("../components/video.vue");
          }
          if (this.$store.state.round == 4) {
            if (this.$store.state.has_game === '1_to_25') {
              return () => import("../components/1to50.vue");
            }

            if (this.$store.state.has_game === 'tic_tac_toe') {
              return () => import("../components/TicTacToe.vue");
            }
          }
          if (this.$store.state.round == 6) {
            return () => import("../components/MysteryBoxes.vue");
          }
        } else if (this.$store.state.matchSlug == 822) {
          if (this.$store.state.round == 2) {
              return () => import("../components/video.vue");
          }
          if (this.$store.state.round == 4) {
              return () => import("../components/TicTacToe.vue");
          }
          if (this.$store.state.round == 6) {
            return () => import("../components/SpinTheWheel.vue");
          }
        }else if (this.$store.state.trivia.creator_id == 7358) {
          if (this.$store.state.round == 2) {
              return () => import("../components/video.vue");
          }
          if (this.$store.state.round == 4) {
            if (this.$store.state.has_game === '1_to_25') {
              return () => import("../components/1to50.vue");
            }
            if (this.$store.state.has_game === 'tic_tac_toe') {
              return () => import("../components/TicTacToe.vue");
            }
          }
        }
        else if (this.$store.state.matchSlug == 838) {
          if (this.$store.state.round == 1) {
              return () => import("../components/video.vue");
          }
          if (this.$store.state.round == 2) {
            if (this.$store.state.has_game === '1_to_25') {
              return () => import("../components/1to50.vue");
            }
            if (this.$store.state.has_game === 'tic_tac_toe') {
              return () => import("../components/TicTacToe.vue");
            }
          }if (this.$store.state.round == 3) {
            return () => import("../components/MysteryBoxes.vue");
          }
        }
        else if (this.$store.state.matchSlug == 846) {
          if (this.$store.state.round == 2) {
              return () => import("../components/video.vue");
          }
          if (this.$store.state.round == 4) {
            if (this.$store.state.has_game === '1_to_25') {
              return () => import("../components/1to50.vue");
            }
            if (this.$store.state.has_game === 'tic_tac_toe') {
              return () => import("../components/TicTacToe.vue");
            }
          }
        }
        else if (this.$store.state.matchSlug == 853) {
          if (this.$store.state.round == 2) {
            if (this.$store.state.has_game === '1_to_25') {
              return () => import("../components/1to50.vue");
            }
            if (this.$store.state.has_game === 'tic_tac_toe') {
              return () => import("../components/TicTacToe.vue");
            }
          }
          if (this.$store.state.round == 4) {
              return () => import("../components/video.vue");
          }
        }
        // else if (this.$store.state.matchSlug == 823) {
        //   if (mystery){
        //     return () => import("../components/MysteryBoxes.vue");
        //   }
        // }
        //  else if (this.$store.state.matchSlug ==1144 ) {
    
        //       return () => import("../components/video.vue");
            

        else if (this.$store.state.matchSlug ==1145 && this.$store.state.round == 2) {
            if (this.$store.state.has_game === 'slide') {
              return () => import("../components/video.vue");
            }
        }else{
          if (slide) {
            return () => import("../components/video.vue");
          }
          if(mystery) {
            return () => import("../components/MysteryBoxes.vue");
          }

          if (this.$store.state.has_game === '1_to_25') {
            return () => import("../components/1to50.vue");
          }

          if (this.$store.state.has_game === 'tic_tac_toe') {
            return () => import("../components/TicTacToe.vue");
          }
        }
      }

      return () => import("../components/Quiz.vue");
    },
    creator_id (){
      let context = this;
      return context.$store.state.trivia;
    }
  },

};
</script>

<style lang="sass" scoped>
.match
  display: grid
  grid-template-rows: auto
</style>
